<template>
  <div class="form-field">
    <label>背景色</label>
    <div class="content">
      <el-color-picker :value="style.backgroundColor" @input="setColorComplete" @active-change="setColor" @close="setColorComplete"/>
    </div>
  </div>
</template>

<script>
  import style from 'mixins/style'

  export default {
    mixins: [ style ],
    data(){
      return {
        value:null
      }
    },
    computed: {
      style() {
        return this.$store.state.mask && this.$store.state.mask[ 0 ] && this.$store.state.mask[ 0 ].style || {}
      }
    },
    methods:{
      setColor(color){
        this.updateStyle('backgroundColor', color)
      },
      setColorComplete(){
        this.$store.commit('color_complete')
      }
    }
  }
</script>
